module.exports = __webpack_public_path__ + "img/1453309680.b65a0e8c.jpg";